import { render, staticRenderFns } from "./roleClearApprove.vue?vue&type=template&id=35adacf4&"
import script from "./roleClearApprove.vue?vue&type=script&lang=js&"
export * from "./roleClearApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35adacf4')) {
      api.createRecord('35adacf4', component.options)
    } else {
      api.reload('35adacf4', component.options)
    }
    module.hot.accept("./roleClearApprove.vue?vue&type=template&id=35adacf4&", function () {
      api.rerender('35adacf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/roleClearApprove.vue"
export default component.exports